<template>
  <div class="drawer">
    <el-drawer
      size="650px"
      :visible.sync="drawerStatus"
      @close="close"
      :append-to-body="true"
      :title="'门店资产'"
      :wrapperClosable="false"
    >
      <el-form :inline="true" class="form">
        <el-row style="padding: 0 10px; float: none">
          <el-col :span="20" :offset="1">
            <el-form-item label="分类:" :label-width="formLabelWidth" required>
              <el-select
                v-model="curType"
                filterable
                placeholder="请选择"
                style="width: 250px"
                :disabled="!$public.isNull(id)"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding: 0 10px; float: none">
          <el-col :span="20" :offset="1">
            <el-form-item label="名称:" :label-width="formLabelWidth" required>
              <el-input
                v-model="name"
                style="width: 250px"
                placeholder="请录入名称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding: 0 10px; float: none">
          <el-col :span="20" :offset="1">
            <el-form-item label="规格:" :label-width="formLabelWidth" required>
              <el-input
                v-model="skuName"
                style="width: 250px"
                placeholder="请录入规格"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding: 0 10px; float: none">
          <el-col :span="20" :offset="1">
            <el-form-item label="图片:" :label-width="formLabelWidth">
              <div class="imgView">
                <div
                  v-for="(item, index) in images"
                  :key="index"
                  class="imgItem"
                >
                  <img alt="" :src="item" />
                  <i
                    class="el-icon-error closeBtn"
                    @click="images.splice(index, 1)"
                  ></i>
                </div>
                <img
                  style="width: 80px; height: 80px"
                  src="../../../assets/img/uploadImg.png"
                  @click="uploadImg"
                />
                <input
                  type="file"
                  ref="file"
                  style="width: 0; height: 0"
                  @change="changeFile"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding: 0 10px; float: none">
          <el-col :span="20" :offset="1">
            <el-form-item label="描述:" :label-width="formLabelWidth">
              <el-input
                v-model="remarks"
                type="textarea"
                :rows="5"
                style="width: 250px"
                placeholder="请录入描述"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding: 0 10px; float: none">
          <el-col :span="20" :offset="1">
            <el-form-item label="包装清单:" :label-width="formLabelWidth">
              <el-button
                type="primary"
                @click="packingList.push('')"
                size="mini"
                >添加</el-button
              >
              <div
                v-for="(item, index) in packingList"
                :key="index"
                style="padding-top: 10px"
              >
                <span style="padding-right: 10px">名称{{ index + 1 }}:</span>
                <el-input
                  v-model="packingList[index]"
                  style="width: 250px"
                  placeholder="请输入"
                ></el-input>
                <el-button
                  style="padding-left: 5px"
                  type="text"
                  @click="packingList.splice(index, 1)"
                >
                  删除</el-button
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="height: 40px; width: 100%"></div>
      <div class="btnBox">
        <div class="btnItem" @click="close">取消</div>
        <div class="btnItem submit" @click="submit">确定</div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawerStatus: false,
      formLabelWidth: "80px",

      curType: "1",
      typeList: [
        { id: "1", name: "办公" },
        { id: "2", name: "器械" },
        { id: "3", name: "用品" },
        { id: "4", name: "其它" },
      ],
      name: "",
      skuName: "",
      images: [],
      remarks: "",
      packingList: [],
    };
  },
  computed: {},
  props: {
    id: {
      default: "",
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
    });
    if (!this.$public.isNull(this.id)) {
      this.$http
        .get(process.env.VUE_APP_zichan + "/api/AssetsInfo/detail", {
          id: this.id,
        })
        .then((res) => {
          if (res.code == 0) {
            this.curType = res.data.type.id;
            this.name = res.data.name;
            this.skuName = res.data.skuName;
            this.images = res.data.images;
            this.remarks = res.data.remarks;
            this.packingList = res.data.packingList;
          }
        });
    }
  },
  methods: {
    close() {
      this.$emit("submit", { type: "close" });
    },
    submit() {
      if (this.$public.isNull(this.name)) {
        this.$message({
          message: "请录入名称",
          type: "error",
        });
        return;
      }
      if (this.$public.isNull(this.skuName)) {
        this.$message({
          message: "请录入规格",
          type: "error",
        });
        return;
      }
      let params = {
        name: this.name,
        skuName: this.skuName,
        type: {
          id: this.curType,
          name: this.$public.getMatchingItem(this.typeList, "id", this.curType)
            .name,
        },
        images: this.images,
        remarks: this.remarks,
        packingList: this.packingList.filter((item) => {
          return item.length > 0;
        }),
      };
      if (this.$public.isNull(this.id)) {
        this.$http
          .post(process.env.VUE_APP_zichan + "/api/AssetsInfo/add", params)
          .then((res) => {
            if (res.code == 0) {
              this.$emit("submit", { type: "success" });
            }
          });
      } else {
        params.id = this.id;
        this.$http
          .post(process.env.VUE_APP_zichan + "/api/AssetsInfo/update", params)
          .then((res) => {
            if (res.code == 0) {
              this.$emit("submit", { type: "success" });
            }
          });
      }
    },
    uploadImg() {
      this.$refs.file.click();
    },
    changeFile(e) {
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext1 = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      var ext = ext1.toLowerCase();
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        let loading = this.$loading();
        this.$util
          .uploadImg_dir(formData, { dir: "uploadImg" })
          .then((data) => {
            loading.close();
            if (data.timestamp) {
              this.images.push(data.url);
            }
          });
      } else {
        this.$message({
          message: "只能上传jpg,jpeg,png格式的文件",
          type: "error",
        });
        return;
      }
      this.$refs.file.value = null;
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .form {
      ::v-deep .el-form-item {
        margin: 5px 0;
      }
    }
  }
}
.imgView {
  flex: 1;
  .imgItem {
    position: relative;
    width: 80px;
    height: 80px;
    margin-right: 20px;
    margin-bottom: 10px;
    float: left;
    img {
      width: 100%;
      height: 100%;
    }
    .closeBtn {
      display: block;
      color: red;
      position: absolute;
      top: -10px;
      right: -10px;
      font-size: 20px;
      z-index: 5;
    }
  }
}
.btnBox {
  width: 100%;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 10;
  .btnItem {
    text-align: center;
    width: 100%;
    background-color: #d6d6d6;
    cursor: pointer;
    &.submit {
      background-color: $mainColor;
    }
  }
}
</style>
